import { render, staticRenderFns } from "./FormAttachmentDoc.vue?vue&type=template&id=66663f3c&"
import script from "./FormAttachmentDoc.vue?vue&type=script&lang=js&"
export * from "./FormAttachmentDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports